import { useMemo } from 'react';

import { useLabels } from '../i18n/useLabels';
import { LABEL_KEYS, type Message } from '../viewmodels/messages';

export type Notifier = {
  notifySuccess: (message: Message) => void;
  notifyFailure: () => void;
  notifyChangesDropped: (count: number) => void;
};

export function useNotifier(): Notifier {
  const { formatMessage } = useLabels();

  return useMemo<Notifier>(() => {
    function show(message: Message): void {
      const text = formatMessage(message);

      window.Toast.show(text);
    }

    return {
      notifySuccess: show,
      notifyFailure: () => show({ key: LABEL_KEYS.operationFailedToast }),
      notifyChangesDropped: count =>
        show({ key: LABEL_KEYS.changesNotAppliedToast, params: { count } }),
    };
  }, [formatMessage]);
}
